var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-icon',{style:(_vm.emptyIcon)},[_vm._v("mdi-circle-small")])}
var staticRenderFns = []

export { render, staticRenderFns }